import { z } from 'zod'

export const BUNDLE_SCHEMA_VERSION = 3 as const

// === BLOCK kinds ===
const BlockBaseFields = {
  id: z.string().min(1),
  markdown: z.string().min(1),
} as const

export const BundleManualeBlockSchema = z.discriminatedUnion('kind', [
  z.object({ kind: z.literal('paragraph'), ...BlockBaseFields }),
  z.object({ kind: z.literal('integration'), ...BlockBaseFields }),
  z.object({ kind: z.literal('correction'), ...BlockBaseFields }),
  z.object({ kind: z.literal('clarification'), ...BlockBaseFields }),
])
export type BundleManualeBlock = z.infer<typeof BundleManualeBlockSchema>

// === NODE kinds ===
export const BundleManualeSubParagraphSchema = z.object({
  kind: z.literal('subParagraph'),
  id: z.string().min(1),
  title: z.string().min(1),
  rationale: z.string().optional(),
  blocks: z.array(BundleManualeBlockSchema).min(1),
})
export type BundleManualeSubParagraph = z.infer<typeof BundleManualeSubParagraphSchema>

export const BundleManualeSubThemeSchema = z.object({
  kind: z.literal('subTheme'),
  id: z.string().min(1),
  title: z.string().min(1),
  rationale: z.string().optional(),
  subParagraphs: z.array(BundleManualeSubParagraphSchema).min(1),
})
export type BundleManualeSubTheme = z.infer<typeof BundleManualeSubThemeSchema>

export const BundleManualeKeyPointsSchema = z.object({
  kind: z.literal('keyPoints'),
  id: z.string().min(1),
  title: z.string().min(1),
  blocks: z.array(BundleManualeBlockSchema).min(1),
})
export type BundleManualeKeyPoints = z.infer<typeof BundleManualeKeyPointsSchema>

export const BundleManualeChapterSchema = z.object({
  kind: z.literal('chapter'),
  id: z.string().min(1),
  title: z.string().min(1),
  rationale: z.string().optional(),
  subThemes: z.array(BundleManualeSubThemeSchema).min(1),
  keyPoints: BundleManualeKeyPointsSchema.nullable(),
})
export type BundleManualeChapter = z.infer<typeof BundleManualeChapterSchema>

export const BundleManualeCompendioSchema = z.object({
  kind: z.literal('compendio'),
  id: z.literal('compendio'),
  title: z.string().min(1),
  subThemes: z.array(BundleManualeSubThemeSchema).min(1),
})
export type BundleManualeCompendio = z.infer<typeof BundleManualeCompendioSchema>

// === ROOT ===
export const AriannaMetaSchema = z
  .object({
    desktopVersion: z.string(),
    promptVersion: z.string(),
  })
  .partial()
  .passthrough()

export const BundleManualeSchema = z
  .object({
    schemaVersion: z.literal(BUNDLE_SCHEMA_VERSION),
    bundleSlug: z.string().min(1),
    bundleVersion: z.string().min(1),
    title: z.string().min(1),
    subtitle: z.string().nullable(),
    author: z.string().min(1),
    createdAt: z.string().datetime(),
    rationale: z.string().optional(),
    arianna: AriannaMetaSchema.optional(),
    compendio: BundleManualeCompendioSchema.nullable(),
    chapters: z.array(BundleManualeChapterSchema).min(1),
  })
  .strict()
export type BundleManuale = z.infer<typeof BundleManualeSchema>
